import firebase from 'firebase/app'
import 'firebase/firebase-firestore';
import fbConfig from './fbConfig'

const firebaseApp = firebase.initializeApp(fbConfig)

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/components/fbInit.js